import { Component, forwardRef, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { ControlValueAccessorConnector } from '../control-value-accessor-connector';

@Component({
  selector: 'app-text-area',
  templateUrl: './text-area.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextAreaComponent),
      multi: true
    }
  ]
})
export class TextAreaComponent extends ControlValueAccessorConnector implements OnInit, ControlValueAccessor {
  @Input() height: number;
  @Input() value: string;
  @Input() attributeId = this.formControlName;
  @Input() labelMaori: string | null;
  @Input() showMaoriLabel: boolean = false;
  @Input() isViewMode: boolean = false;

  // Reworking hideWarning and showRequiredForApproval interactions needs to be done with proper care and extensive testing so existing functionality does not break
  // Leave it as is for now
  @Input() hideWarning: boolean = false;
  @Input() showRequiredForApproval: boolean = false;

  get maxLengthError(): string {
    return `The maximum length of this field is ${this.maxlength} characters.`;
  }

  /**
   * This works somehow, but I honestly don't know why.
   * It must have something to do with the control value accessor.
   */
  @Input() maxlength: number = 1000;

  settings: any;

  constructor() {
    super();
  }

  ngOnInit(): void {
    this.settings = {
      base_url: '/tinymce', // Root for resources
      suffix: '.min', // Suffix to use when loading resources
      tagName: this.formControlName,
      height: this.height,
      menubar: false,
      plugins: ['lists', 'link', 'help'],
      toolbar: ['bold | italic | underline | bullist | numlist | link | unlink | undo | redo | help'],
      branding: false,
      //style the background color of the editor when disabled
      content_style: '.mce-content-readonly { background-color: #e9ecef; }',
      elementpath: false,
      help_accessibility: false
    };
  }

  /**
   * The tinymce-angular wrapper only re-applies a value written to it before the underlying
   * TinyMCE instance finished initialising when that value is a string - a control written to with
   * null/undefined (e.g. on a fast form rebuild) is silently dropped and the editor is left blank
   * even though the control's actual value is populated. Explicitly re-syncing the displayed
   * content once TinyMCE reports ready guards against that regardless of the write timing.
   */
  onEditorInit(event: { editor: { getContent: () => string; setContent: (value: string) => void } }): void {
    const currentValue = (this.formGroup ? this.control?.value : this.value) ?? '';
    if (event.editor.getContent() !== currentValue) {
      event.editor.setContent(currentValue);
    }
  }
}
